import { Extension } from '@tiptap/core';
import Image from '@tiptap/extension-image';
import Link from '@tiptap/extension-link';
import Subscript from '@tiptap/extension-subscript';
import Superscript from '@tiptap/extension-superscript';
import { Table, TableCell, TableHeader, TableRow } from '@tiptap/extension-table';
import TextAlign from '@tiptap/extension-text-align';
import { TextStyleKit } from '@tiptap/extension-text-style';
import Underline from '@tiptap/extension-underline';
import StarterKit from '@tiptap/starter-kit';
import { buildInlineStyle } from './helpers';

export const TIPTAP_FONT_FAMILIES = ['Arial', 'Georgia', 'Roboto', 'Times New Roman', 'Verdana'];
export const TIPTAP_FONT_SIZES = ['12px', '14px', '16px', '18px', '24px', '30px'];

const LegacyIndentation = Extension.create({
  name: 'legacyIndentation',
  addGlobalAttributes() {
    return [
      {
        types: ['heading', 'paragraph', 'listItem', 'bulletList', 'orderedList'],
        attributes: {
          marginLeft: {
            default: null,
            parseHTML: element => element.style.marginLeft || null,
            renderHTML: buildInlineStyle
          },
          paddingLeft: {
            default: null,
            parseHTML: element => element.style.paddingLeft || null,
            renderHTML: buildInlineStyle
          },
          textIndent: {
            default: null,
            parseHTML: element => element.style.textIndent || null,
            renderHTML: buildInlineStyle
          }
        }
      }
    ];
  }
});

const RichTextUnderline = Underline.extend({
  parseHTML() {
    return [
      { tag: 'ins' },
      ...(this.parent?.() || [])
    ];
  }
});

const RichTextLink = Link.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      target: {
        default: this.options.HTMLAttributes.target,
        parseHTML: element => element.getAttribute('target') || this.options.HTMLAttributes.target
      },
      rel: {
        default: this.options.HTMLAttributes.rel,
        parseHTML: element => element.getAttribute('rel') || this.options.HTMLAttributes.rel
      },
      class: {
        default: this.options.HTMLAttributes.class,
        parseHTML: element => element.getAttribute('class')
      },
      title: {
        default: null,
        parseHTML: element => element.getAttribute('title')
      }
    };
  }
});

const RichTextImage = Image.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      src: {
        default: null,
        parseHTML: element => element.getAttribute('src')
      },
      alt: {
        default: null,
        parseHTML: element => element.getAttribute('alt')
      },
      title: {
        default: null,
        parseHTML: element => element.getAttribute('title')
      },
      width: {
        default: null,
        parseHTML: element => element.getAttribute('width')
      },
      height: {
        default: null,
        parseHTML: element => element.getAttribute('height')
      },
      style: {
        default: null,
        parseHTML: element => element.getAttribute('style')
      },
      class: {
        default: null,
        parseHTML: element => element.getAttribute('class')
      }
    };
  }
});

export const TIPTAP_EXTENSIONS = [
  StarterKit,
  LegacyIndentation,
  RichTextUnderline,
  RichTextLink.configure({
    openOnClick: false,
    autolink: true
  }),
  RichTextImage.configure({
    allowBase64: true
  }),
  Table.configure({
    resizable: true
  }),
  TableRow,
  TableHeader,
  TableCell,
  TextAlign.configure({
    types: ['heading', 'paragraph']
  }),
  Subscript,
  Superscript,
  TextStyleKit
];
